/**
 * EmbeddedLayout Component
 *
 * Layout for nested pages that don't need their own page structure:
 * - No background color (transparent - inherits from parent)
 * - No page header (parent page handles title/tabs)
 * - Flex column layout for content flow
 *
 * Use this for pages that are rendered within another page's tab content
 * or as embedded views.
 */

import { ReactNode } from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    // No background color - transparent/inherited
    // No padding - parent controls spacing
  },
});

export interface EmbeddedLayoutProps {
  /** Content to render */
  children: ReactNode;
  /** Test ID for the component */
  testId?: string;
}

export function EmbeddedLayout({ children, testId }: EmbeddedLayoutProps) {
  const styles = useStyles();

  return (
    <div className={styles.container} data-testid={testId}>
      {children}
    </div>
  );
}
